import BasePage from "@/infrastructure/BasePage/basePage.component";
import React from "react";
import { useTranslation } from "react-i18next";

type PageNotFoundProps = {
  // TODO: add props here
};

const PageNotFound: React.FC<PageNotFoundProps> = (props) => {
  const { t } = useTranslation();
  return (
    <BasePage currPage="notFound">
      <div className="container m-auto flex items-center justify-center">
        <h1 className="mb-3 text-center text-3xl font-bold">
          {t("Page Not Found")}
        </h1>
      </div>
    </BasePage>
  );
};

export default PageNotFound;
